import api from './axios';

export const getDelegations    = (params) => api.get('/delegations', { params });
export const createDelegation  = (data)   => api.post('/delegations', data);
export const updateDelegation  = (id, data) => api.patch(`/delegations/${id}`, data);
export const deleteDelegation  = (id)    => api.delete(`/delegations/${id}`);
